import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AppShell } from "@/layouts/AppShell";
import { RequireAuth } from "@/components/layout/RequireAuth";
import { RedirectPipelineDeal } from "@/components/layout/RedirectPipelineDeal";
import { DashboardPage } from "@/pages/core/DashboardPage";
import { DocumentsPage } from "@/pages/core/DocumentsPage";
import { FolderTemplatesPage } from "@/pages/core/FolderTemplatesPage";
import { AccountPage } from "@/pages/core/AccountPage";
import { AccountManagementPage } from "@/pages/core/AccountManagementPage";
import { LoginPage } from "@/pages/core/LoginPage";
import { SetPasswordPage } from "@/pages/core/SetPasswordPage";
import { NotificationPreferencesPage } from "@/pages/core/NotificationPreferencesPage";
import { NotificationsFeedPage } from "@/pages/core/NotificationsFeedPage";
import { PlaceholderPage } from "@/pages/core/PlaceholderPage";
import { NotFoundPage } from "@/pages/core/NotFoundPage";
import LoanDetailPage from "@/pages/portfolioAdmin/LoanDetailPage";
import LegalReviewWorkspacePage from "@/pages/compliance/LegalReviewWorkspacePage";
import ComplianceCockpitPage from "@/pages/compliance/ComplianceCockpitPage";
import QualityAssuranceCockpitPage from "@/pages/compliance/QualityAssuranceCockpitPage";
import DefaultsWorkoutCockpitPage from "@/pages/compliance/DefaultsWorkoutCockpitPage";
import LoansListPage from "@/pages/portfolioAdmin/LoansListPage";
import PortfoliosListPage from "@/pages/portfolioAdmin/PortfoliosListPage";
import LoanPaymentsPage from "@/pages/portfolioAdmin/finance/LoanPaymentsPage";
import FeesLedgerPage from "@/pages/portfolioAdmin/finance/FeesLedgerPage";
import FeeReviewPage from "@/pages/portfolioAdmin/finance/FeeReviewPage";
import StatementQueuePage from "@/pages/portfolioAdmin/finance/StatementQueuePage";
import ServicingReviewQueuePage from "@/pages/portfolioAdmin/finance/ServicingReviewQueuePage";
import ServicingReviewDetailPage from "@/pages/portfolioAdmin/finance/ServicingReviewDetailPage";
import CostRecoveryPage from "@/pages/portfolioAdmin/finance/CostRecoveryPage";
import CardSurchargeConfigPage from "@/pages/portfolioAdmin/finance/CardSurchargeConfigPage";
import CommissionModelerTermsPage from "@/pages/portfolioAdmin/finance/CommissionModelerTermsPage";
import TpsOversightPage from "@/pages/portfolioAdmin/finance/TpsOversightPage";
import TransitionsConsolePage from "@/pages/portfolioAdmin/finance/TransitionsConsolePage";
import IncomeOverviewPage from "@/pages/portfolioAdmin/finance/IncomeOverviewPage";
import IncomeOverviewLoanPage from "@/pages/portfolioAdmin/finance/IncomeOverviewLoanPage";
import PortfolioDashboardPage from "@/pages/portfolioAdmin/PortfolioDashboardPage";
import RightSizeWizard from "@/pages/portfolioAdmin/RightSizeWizard";
import ResaleWizard from "@/pages/portfolioAdmin/ResaleWizard";
import FinancialClosingWizard from "@/pages/portfolioAdmin/FinancialClosingWizard";
import VendorsListPage from "@/pages/portfolioAdmin/VendorsListPage";
import VendorDetailPage from "@/pages/portfolioAdmin/VendorDetailPage";
import VendorComplaintsPage from "@/pages/portfolioAdmin/VendorComplaintsPage";
import VendorAuditsPage from "@/pages/portfolioAdmin/VendorAuditsPage";
import VfiAccountingPage from "@/pages/portfolioAdmin/VfiAccountingPage";
import LocalEnforcersListPage from "@/pages/portfolioAdmin/LocalEnforcersListPage";
import LocalEnforcerDetailPage from "@/pages/portfolioAdmin/LocalEnforcerDetailPage";
import BackgroundChecksPage from "@/pages/backgroundChecks/BackgroundChecksPage";
import BackgroundCheckDetailPage from "@/pages/backgroundChecks/BackgroundCheckDetailPage";
import LienDetailPage from "@/pages/backgroundChecks/LienDetailPage";
import LitigationDetailPage from "@/pages/backgroundChecks/LitigationDetailPage";
import BgcUccFilingDetailPage from "@/pages/backgroundChecks/BgcUccFilingDetailPage";
import WaterfallsListPage from "@/pages/portfolioAdmin/WaterfallsListPage";
import WaterfallDetailPage from "@/pages/portfolioAdmin/WaterfallDetailPage";
import LoanTapePage from "@/pages/portfolioAdmin/LoanTapePage";
import MetricsPage from "@/pages/portfolioAdmin/MetricsPage";
import ReportingPage from "@/pages/portfolioAdmin/ReportingPage";
import TpsListPage from "@/pages/portfolioAdmin/tps/TpsListPage";
import TpsDetailPage from "@/pages/portfolioAdmin/tps/TpsDetailPage";
import { RolesPage } from "@/pages/core/RolesPage";
import { AdminRolesPage } from "@/pages/core/AdminRolesPage";
import { AdminCategoriesPage } from "@/pages/core/AdminCategoriesPage";
import { DocumentRequestTemplatesPage } from "@/pages/admin/DocumentRequestTemplatesPage";
import { UsersPage } from "@/pages/core/UsersPage";
import { QualificationFieldsAdminPage } from "@/pages/core/QualificationFieldsAdminPage";
import { AdminHubPage } from "@/pages/core/AdminHubPage";
import { StyleGuidePage } from "@/pages/admin/StyleGuidePage";
import { BrandIdentityPage } from "@/pages/core/BrandIdentityPage";
import { ProfileEditPage } from "@/pages/profile/ProfileEditPage";
import { ProfileViewPage } from "@/pages/profile/ProfileViewPage";
import { ReportTemplatesPage } from "@/pages/reports/ReportTemplatesPage";
import { ReportTemplateEditPage } from "@/pages/reports/ReportTemplateEditPage";
import { CollectionTemplatesPage } from "@/pages/admin/collection/CollectionTemplatesPage";
import { PromptsAdminPage } from "@/pages/admin/PromptsAdminPage";
import { EmailTemplatesPage } from "@/pages/admin/EmailTemplatesPage";
import { InterviewWordingPage } from "@/pages/admin/InterviewWordingPage";
import { EmailTemplateEditorPage } from "@/pages/admin/EmailTemplateEditorPage";
import { NotificationsAdminPage } from "@/pages/admin/notifications/NotificationsAdminPage";
import { NotificationComposePage } from "@/pages/admin/notifications/NotificationComposePage";
import { NotificationDetailPage } from "@/pages/admin/notifications/NotificationDetailPage";
import { CollectionTemplateEditPage } from "@/pages/admin/collection/CollectionTemplateEditPage";
import { CollectionTemplateBundlesPage } from "@/pages/admin/collection/CollectionTemplateBundlesPage";
import { CollectionTemplateBundleEditPage } from "@/pages/admin/collection/CollectionTemplateBundleEditPage";
import { DealSubmissionTemplatesPage } from "@/pages/admin/deal-submission/DealSubmissionTemplatesPage";
import { DealSubmissionTemplateEditPage } from "@/pages/admin/deal-submission/DealSubmissionTemplateEditPage";
import { PortalAccountsPage } from "@/pages/admin/portal/PortalAccountsPage";
import { PortalAccountDetailPage } from "@/pages/admin/portal/PortalAccountDetailPage";
import { PortalSignupLinkPage } from "@/pages/admin/portal/PortalSignupLinkPage";
import { CollectionStagingQueuePage } from "@/pages/collection/CollectionStagingQueuePage";
import { CollectionStagingReviewPage } from "@/pages/collection/CollectionStagingReviewPage";
import { GlobalReviewQueuePage } from "@/pages/collection/GlobalReviewQueuePage";
import { DealStagingQueuePage } from "@/pages/deal-flow/deal-staging/DealStagingQueuePage";
import { DealStagingReviewPage } from "@/pages/deal-flow/deal-staging/DealStagingReviewPage";
import { CollectionPackageNewPage } from "@/pages/collection/CollectionPackageNewPage";
import { CollectionPackageDetailPage } from "@/pages/collection/CollectionPackageDetailPage";
import { ReportsPage } from "@/pages/reports/ReportsPage";
import { EscrowListPage } from "@/pages/escrow/EscrowListPage";
import { EscrowDetailPage } from "@/pages/escrow/EscrowDetailPage";
import { ReportGeneratePage } from "@/pages/reports/ReportGeneratePage";
import { ReportViewerPage } from "@/pages/reports/ReportViewerPage";
import { ReportDetailRouter } from "@/pages/reports/v32/ReportDetailRouter";
import { BrokersPage } from "@/pages/brokers/BrokersPage";
import { BrokerDetailPage } from "@/pages/brokers/BrokerDetailPage";
import { BrokerEditPage } from "@/pages/brokers/BrokerEditPage";
import { BrokerApplicationsPage } from "@/pages/brokers/BrokerApplicationsPage";
import { BrokerTeamsPage } from "@/pages/brokers/BrokerTeamsPage";
import { BrokerTeamDashboardPage } from "@/pages/brokers/BrokerTeamDashboardPage";
import { LeadsPage } from "@/pages/leads/LeadsPage";
import { LeadEditPage } from "@/pages/leads/LeadEditPage";
import { LeadDetailPage } from "@/pages/leads/LeadDetailPage";
import { LeadImportPage } from "@/pages/leads/LeadImportPage";
// Lead Generation System — internal management pages.
import { PreleadsListPage } from "@/pages/leadGeneration/PreleadsListPage";
import { GeneratorsRosterPage } from "@/pages/leadGeneration/GeneratorsRosterPage";
import { GeneratorDetailPage } from "@/pages/leadGeneration/GeneratorDetailPage";
import { EarningsReviewPage } from "@/pages/leadGeneration/EarningsReviewPage";
import { PayPeriodLedgerPage } from "@/pages/leadGeneration/PayPeriodLedgerPage";
import CompensationPlanSettingsPage from "@/pages/leadGeneration/CompensationPlanSettingsPage";
import { BrokeragesPage } from "@/pages/brokerages/BrokeragesPage";
import { BrokerageEditPage } from "@/pages/brokerages/BrokerageEditPage";
import { BrokerageDetailPage } from "@/pages/brokerages/BrokerageDetailPage";
// Buyer CRM (PR 2a) — the buy-side pipeline.
import { BuyersListPage } from "@/pages/buyers/BuyersListPage";
import { BuyerDetailPage } from "@/pages/buyers/BuyerDetailPage";
import { BuyerEditPage } from "@/pages/buyers/BuyerEditPage";
import { BuyerImportPage } from "@/pages/buyers/BuyerImportPage";
import { ListingsListPage } from "@/pages/buyers/ListingsListPage";
import { ListingDetailPage } from "@/pages/buyers/ListingDetailPage";
import { ListingAgentResearchPage } from "@/pages/buyers/listing/agentResearch/ListingAgentResearchPage";
import { BuyerSubmissionsListPage } from "@/pages/buyers/BuyerSubmissionsListPage";
import { BuyerSubmissionDetailPage } from "@/pages/buyers/BuyerSubmissionDetailPage";
import { BuyerAssignmentQueuePage } from "@/pages/buyers/BuyerAssignmentQueuePage";
import { BuyerAllocationSettingsPage } from "@/pages/buyers/BuyerAllocationSettingsPage";
import { BuyerTeamsPage } from "@/pages/buyers/BuyerTeamsPage";
import { BuyerReportsPage } from "@/pages/buyers/reports/BuyerReportsPage";
import { BuyerTeamDetailPage } from "@/pages/buyers/BuyerTeamDetailPage";
import { BuyerAdvertisingPage } from "@/pages/buyers/advertising/BuyerAdvertisingPage";
import { TerritoriesPage } from "@/pages/territories/TerritoriesPage";
import { CommissionsPage } from "@/pages/commissions/CommissionsPage";
import { ClaimEntryPage } from "@/pages/commissions/ClaimEntryPage";
import { ClaimDetailPage } from "@/pages/commissions/ClaimDetailPage";
import { BulkEntryPage } from "@/pages/commissions/BulkEntryPage";
import { PoolAdminPage } from "@/pages/commissions/PoolAdminPage";
import { PeriodAdminPage } from "@/pages/commissions/PeriodAdminPage";
import { TemplatesPage } from "@/pages/commissions/TemplatesPage";
import { InboxPage } from "@/pages/messaging/InboxPage";
import { ThreadPage } from "@/pages/messaging/ThreadPage";
import { TasksListPage } from "@/pages/tasks/TasksListPage";
import { TaskDetailPage } from "@/pages/tasks/TaskDetailPage";
import { CalendarPage } from "@/pages/calendar/CalendarPage";
import { CommunicationsInboxPage } from "@/pages/communications/CommunicationsInboxPage";
import { CommunicationDetailPage } from "@/pages/communications/CommunicationDetailPage";
import { BorrowersPage, SellersPage } from "@/pages/parties/PartiesListPage";
import { BorrowerDetailPage, SellerDetailPage } from "@/pages/parties/PartyDetailPage";
import { BorrowerEditPage, SellerEditPage } from "@/pages/parties/PartyEditPage";
import { PersonListPage } from "@/pages/counterparties/persons/PersonListPage";
import { PersonDetailPage } from "@/pages/counterparties/persons/PersonDetailPage";
import { PersonEditPage } from "@/pages/counterparties/persons/PersonEditPage";
import { EntityListPage } from "@/pages/counterparties/entities/EntityListPage";
import { EntityDetailPage } from "@/pages/counterparties/entities/EntityDetailPage";
import { EntityEditPage } from "@/pages/counterparties/entities/EntityEditPage";
import { BusinessListPage } from "@/pages/counterparties/businesses/BusinessListPage";
import { BusinessDetailPage } from "@/pages/counterparties/businesses/BusinessDetailPage";
import { BusinessEditPage } from "@/pages/counterparties/businesses/BusinessEditPage";
import { TagManagementPage } from "@/pages/admin/tasks/TagManagementPage";
import { CertificationsAdminPage } from "@/pages/admin/certifications/CertificationsAdminPage";
import { AdminAllClaimsPage } from "@/pages/admin/commissions/AdminAllClaimsPage";
import { AdminPaymentLedgerPage } from "@/pages/admin/commissions/AdminPaymentLedgerPage";
import { AllocationAdminPage } from "@/pages/admin/commissions/AllocationAdminPage";
import { CommissionRatesPage } from "@/pages/admin/commissions/CommissionRatesPage";
import { PipelinePage } from "@/pages/deals/PipelinePage";
import { PipelineArchivePage } from "@/pages/deals/PipelineArchivePage";
import { DealDetailPage } from "@/pages/deals/DealDetailPage";
import { DealEditPage } from "@/pages/deals/DealEditPage";
import { PipelineKeyboardShortcuts } from "@/components/deals/PipelineKeyboardShortcuts";
import { MetricsDashboard } from "@/pages/dealFlow/MetricsDashboard";
import { FailureTrackingPage } from "@/pages/dealFlow/FailureTrackingPage";
import { EscalationsPage } from "@/pages/dealFlow/EscalationsPage";
import { AdminBypassConsolePage } from "@/pages/dealFlow/AdminBypassConsolePage";
import { PrequalificationListPage } from "@/pages/dealFlow/PrequalificationListPage";
import { PrequalificationDetailPage } from "@/pages/dealFlow/PrequalificationDetailPage";
import { PrequalDocumentEditorPage } from "@/pages/dealFlow/PrequalDocumentEditorPage";
import { ProgramBrochurePage } from "@/pages/dealFlow/ProgramBrochurePage";
import {
  PrequalificationAssistExplorerPage,
  PrequalificationAssistPage,
  PrequalificationAssistResultPage,
} from "@/pages/dealFlow/PrequalificationAssistPage";
import { PrequalBrandProvider } from "@/portal/pages/prequalify/PrequalBrandContext";
import { PartnerBrandsListPage } from "@/pages/partners/PartnerBrandsListPage";
import { PartnerBrandEditPage } from "@/pages/partners/PartnerBrandEditPage";
import { PartnerBrandCreateWizard } from "@/pages/partners/PartnerBrandCreateWizard";
import { ReunderwritingPipelinePage } from "@/pages/reunderwriting/ReunderwritingPipelinePage";
import { ReunderwritingCaseDetailPage } from "@/pages/reunderwriting/ReunderwritingCaseDetailPage";
import { ReunderwritingMetricsDashboard } from "@/pages/reunderwriting/ReunderwritingMetricsDashboard";
import { ReunderwritingFailureTrackingPage } from "@/pages/reunderwriting/ReunderwritingFailureTrackingPage";
import { ReunderwritingEscalationsPage } from "@/pages/reunderwriting/ReunderwritingEscalationsPage";
import { GonePage } from "@/components/GonePage";
import { Dashboard as CapitalMarketsDashboard } from "@/pages/capital-markets/Dashboard";
import { PoolListPage } from "@/pages/capital-markets/pools/PoolListPage";
import { PoolDetailPage } from "@/pages/capital-markets/pools/PoolDetailPage";
import { PoolFormPage } from "@/pages/capital-markets/pools/PoolFormPage";
import { InvestorClosingWizard } from "@/pages/capital-markets/pools/InvestorClosingWizard";
import { VfiInflowWizard } from "@/pages/capital-markets/pools/VfiInflowWizard";
import { TrustListPage } from "@/pages/capital-markets/trusts/TrustListPage";
import { TrustDetailPage } from "@/pages/capital-markets/trusts/TrustDetailPage";
import { TrustFormPage } from "@/pages/capital-markets/trusts/TrustFormPage";
import { InvestorListPage } from "@/pages/capital-markets/investors/InvestorListPage";
import { InvestorDetailPage } from "@/pages/capital-markets/investors/InvestorDetailPage";
import { ServiceProvidersLandingPage } from "@/pages/capital-markets/service-providers/ServiceProvidersLandingPage";
import { ServiceProviderDetailPage } from "@/pages/capital-markets/service-providers/ServiceProviderDetailPage";
import { PROVIDER_CONFIGS } from "@/pages/capital-markets/service-providers/providerConfig";
import { PirsListPage } from "@/pages/pirs/PirsListPage";
import { PirDetailPage } from "@/pages/pirs/PirDetailPage";
import { PirGeneratePage } from "@/pages/pirs/PirGeneratePage";
import { ServicerInstructionsListPage } from "@/pages/servicerInstructions/ServicerInstructionsListPage";
import { ServicerInstructionDetailPage } from "@/pages/servicerInstructions/ServicerInstructionDetailPage";
import { ServicerInstructionGeneratePage } from "@/pages/servicerInstructions/ServicerInstructionGeneratePage";
import { LoanActivityLedgerPage } from "@/pages/ledgers/LoanActivityLedgerPage";
import { PoolLedgerPage } from "@/pages/ledgers/PoolLedgerPage";
import { InvestorLedgerPage } from "@/pages/ledgers/InvestorLedgerPage";
import { TierLedgerPage } from "@/pages/ledgers/TierLedgerPage";
import { KnowledgeBasePage } from "@/pages/knowledgeBase/KnowledgeBasePage";
import { KnowledgeBaseDocumentsAdminPage } from "@/pages/admin/knowledgeBase/KnowledgeBaseDocumentsAdminPage";
import { KnowledgeBaseCategoriesAdminPage } from "@/pages/admin/knowledgeBase/KnowledgeBaseCategoriesAdminPage";
import { KnowledgeBaseTagsAdminPage } from "@/pages/admin/knowledgeBase/KnowledgeBaseTagsAdminPage";
import { KnowledgeBaseAccessMatrixPage } from "@/pages/admin/knowledgeBase/KnowledgeBaseAccessMatrixPage";
import { KnowledgeBaseQueriesAdminPage } from "@/pages/admin/knowledgeBase/KnowledgeBaseQueriesAdminPage";
import { KnowledgeBaseClassificationAccuracyPage } from "@/pages/admin/knowledgeBase/KnowledgeBaseClassificationAccuracyPage";
import { PortalMaterialsAdminPage } from "@/pages/admin/portalMaterials/PortalMaterialsAdminPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Welcome-email landing — anonymous; the one-time token is the
          proof of identity. */}
      <Route path="/set-password" element={<SetPasswordPage />} />

      {/* Assisted prequalification — a staff member drives an applicant's form
          in the same sitting. OUTSIDE the AppShell on purpose: the shared funnel
          renders its own full-bleed public chrome, and the same-sitting
          mechanism is handing the client the laptop, so an internal work queue
          around their application would be exactly wrong.

          Mounted under `/deal-flow/prequalify/...` rather than a plain
          `/prequalify/...` for two reasons that both bite silently otherwise:
          main.tsx routes any path STARTING with `/prequalify` to the isolated
          portal bundle (which has no staff session), and the funnel derives its
          own in-funnel links from the first `/prequalify` segment of the current
          path — so this prefix is what makes the form's post-finalize
          navigation land on a route this app actually has. */}
      {/* The staff half of the flow shares the portal's brand provider, so an
          assisted application and the result screen it navigates to resolve the
          partner the same way on both sides of the bundle split. It renders no
          DOM and, on these routes, no request: none of them carries a `:slug`,
          so the site comes from the DRAFT (assist) and from the finalized
          result (result screen) via an inner `source`. */}
      <Route element={<PrequalBrandProvider />}>
        <Route
          path="deal-flow/prequalify/assist/:draftId"
          element={
            <RequireAuth permission="Prequalification.Manage">
              <PrequalificationAssistPage />
            </RequireAuth>
          }
        />
        {/* Where the form navigates itself after FINALIZE. The result screen is
            the applicant's own — reference number, validity, the documents to hand
            over — and it reads what the form just wrote to this tab. */}
        <Route
          path="deal-flow/prequalify/buyer/result"
          element={
            <RequireAuth permission="Prequalification.Manage">
              <PrequalificationAssistResultPage role="Buyer" />
            </RequireAuth>
          }
        />
        <Route
          path="deal-flow/prequalify/seller/result"
          element={
            <RequireAuth permission="Prequalification.Manage">
              <PrequalificationAssistResultPage role="Seller" />
            </RequireAuth>
          }
        />
        {/* Where the buyer result screen's "Model a deal" card goes. The card
            builds `{base}/explore` from the first `/prequalify` segment of the
            current path, so on this side it asks for THIS path — and the public
            funnel has had the route since the Explorer shipped while this
            namespace did not, which made one card a 404 for staff only.

            Registered here rather than fixing the link, because the link is
            right: the same card on the same screen resolves correctly on every
            public path, native and partner alike. */}
        <Route
          path="deal-flow/prequalify/explore"
          element={
            <RequireAuth permission="Prequalification.Manage">
              <PrequalificationAssistExplorerPage />
            </RequireAuth>
          }
        />
      </Route>

      <Route
        element={
          <RequireAuth>
            <PipelineKeyboardShortcuts>
              <AppShell />
            </PipelineKeyboardShortcuts>
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="account" element={<AccountManagementPage />} />
        <Route path="account/password" element={<AccountPage />} />
        <Route path="account/profile" element={<ProfileViewPage />} />
        <Route path="account/profile/edit" element={<ProfileEditPage />} />
        <Route path="account/profile/:userId" element={<ProfileViewPage />} />
        <Route path="settings/notifications" element={<NotificationPreferencesPage />} />
        {/* Alias under /profile per Deal Pipeline spec §8.2 wording. */}
        <Route path="profile/notifications" element={<NotificationPreferencesPage />} />
        <Route path="notifications" element={<NotificationsFeedPage />} />
        <Route path="documents" element={<RequireAuth permission="Documents.Read"><DocumentsPage /></RequireAuth>} />
        <Route path="admin/folder-templates" element={<RequireAuth permission="Documents.ManageTemplates"><FolderTemplatesPage /></RequireAuth>} />
        <Route path="admin" element={<AdminHubPage />} />
        {/* Internal design reference. Reuses System.Configure — the standards
            are internal documents and this is their live half, so it needs no
            permission of its own. */}
        <Route
          path="admin/style-guide"
          element={
            <RequireAuth permission="System.Configure">
              <StyleGuidePage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/brand-identity"
          element={
            <RequireAuth permission="System.ManageBrandSettings">
              <BrandIdentityPage />
            </RequireAuth>
          }
        />
        <Route path="admin/users" element={<RequireAuth permission="Users.Read"><UsersPage /></RequireAuth>} />
        <Route path="admin/qualification-fields" element={<RequireAuth permission="System.Configure"><QualificationFieldsAdminPage /></RequireAuth>} />
        {/* Admin-managed Lookups v1.0 — admin CRUD on the Role + Category
            taxonomy tables. /admin/roles is the new lookup page; the
            legacy permission-matrix tool lives at /admin/roles-permissions. */}
        <Route path="admin/roles" element={<RequireAuth permission="Lookups.ManageRoles"><AdminRolesPage /></RequireAuth>} />
        <Route path="admin/roles-permissions" element={<RequireAuth permission="System.Configure"><RolesPage /></RequireAuth>} />
        <Route path="admin/categories" element={<RequireAuth permission="Lookups.ManageCategories"><AdminCategoriesPage /></RequireAuth>} />
        {/* Deal Pipeline spec §3.6 — master Pre-Approval document request catalog. */}
        <Route path="admin/document-request-templates" element={<RequireAuth permission="DocumentRequestTemplates.Manage"><DocumentRequestTemplatesPage /></RequireAuth>} />
        <Route
          path="admin/audit"
          element={
            <RequireAuth permission="System.AuditView">
              <PlaceholderPage phase="Admin" title="Audit Log" description="Filter and review the append-only audit trail." />
            </RequireAuth>
          }
        />
        <Route
          path="admin/report-templates"
          element={
            <RequireAuth permission="Reports.ManageTemplates">
              <ReportTemplatesPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/report-templates/new"
          element={
            <RequireAuth permission="Reports.ManageTemplates">
              <ReportTemplateEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/report-templates/:id"
          element={
            <RequireAuth permission="Reports.ManageTemplates">
              <ReportTemplateEditPage />
            </RequireAuth>
          }
        />
        {/* Centralized AI Prompt Configuration — admin "Prompts" tool: the unified
            store, the in-code catalog, and legacy reconciliation (copy + compare). */}
        <Route
          path="admin/prompts"
          element={
            <RequireAuth permission="Prompts.Manage">
              <PromptsAdminPage />
            </RequireAuth>
          }
        />
        {/* Admin-editable outbound email copy — the EmailTemplateCatalog overlaid
            with the override store. ADMIN-only via
            Communications.ManageEmailTemplates (in Permissions.All, in no role
            map). Saving an edit is a draft; publishing is what changes what
            sends. */}
        <Route
          path="admin/email-templates"
          element={
            <RequireAuth permission="Communications.ManageEmailTemplates">
              <EmailTemplatesPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/email-templates/:key"
          element={
            <RequireAuth permission="Communications.ManageEmailTemplates">
              <EmailTemplateEditorPage />
            </RequireAuth>
          }
        />
        {/* Admin-editable wording of the buyer qualification interview — words
            only, never keys or structure. ADMIN-only via
            Buyers.ManageInterviewWording (in Permissions.All, in no role map).
            Saving is a draft; publishing is what changes what the interview,
            documents and research read. */}
        <Route
          path="admin/interview-wording"
          element={
            <RequireAuth permission="Buyers.ManageInterviewWording">
              <InterviewWordingPage />
            </RequireAuth>
          }
        />
        {/* External Intake & Collection v1.0 PR 2 — System-Admin authoring
            for collection templates. Gated by Collection.ManageTemplates,
            which is ADMIN-only per the permission catalog. */}
        <Route
          path="admin/collection-templates"
          element={
            <RequireAuth permission="Collection.ManageTemplates">
              <CollectionTemplatesPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/collection-templates/new"
          element={
            <RequireAuth permission="Collection.ManageTemplates">
              <CollectionTemplateEditPage />
            </RequireAuth>
          }
        />
        {/* External Collection → Notifications — staff broadcast to external
            portal users. Gated by Portal.ManageAccounts. */}
        <Route
          path="admin/notifications"
          element={
            <RequireAuth permission="Portal.ManageAccounts">
              <NotificationsAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/notifications/new"
          element={
            <RequireAuth permission="Portal.ManageAccounts">
              <NotificationComposePage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/notifications/:id"
          element={
            <RequireAuth permission="Portal.ManageAccounts">
              <NotificationDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/collection-templates/:id"
          element={
            <RequireAuth permission="Collection.ManageTemplates">
              <CollectionTemplateEditPage />
            </RequireAuth>
          }
        />
        {/* Tier 2 #11 — admin CRUD for template bundles. Same gate as the
            template catalog above. */}
        <Route
          path="admin/collection-bundles"
          element={
            <RequireAuth permission="Collection.ManageTemplates">
              <CollectionTemplateBundlesPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/collection-bundles/new"
          element={
            <RequireAuth permission="Collection.ManageTemplates">
              <CollectionTemplateBundleEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/collection-bundles/:id"
          element={
            <RequireAuth permission="Collection.ManageTemplates">
              <CollectionTemplateBundleEditPage />
            </RequireAuth>
          }
        />
        {/* Deal Submission spec §10 — System-Admin authoring for
            DealSubmissionTemplate. Parallel to /admin/collection-templates;
            gated by DealSubmission.ManageTemplates (every staff role holds it). */}
        <Route
          path="admin/deal-submission-templates"
          element={
            <RequireAuth permission="DealSubmission.ManageTemplates">
              <DealSubmissionTemplatesPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/deal-submission-templates/new"
          element={
            <RequireAuth permission="DealSubmission.ManageTemplates">
              <DealSubmissionTemplateEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/deal-submission-templates/:id"
          element={
            <RequireAuth permission="DealSubmission.ManageTemplates">
              <DealSubmissionTemplateEditPage />
            </RequireAuth>
          }
        />
        {/* Remediation Tier 2 #9 (Prompt 9-i) — staff registry over the
            typed external portal accounts (Broker / Buyer / Seller /
            Vendor) and their polymorphic attachments. Gated by
            Portal.ManageAccounts (seeded ADMIN-only via Permissions.All;
            per-role grants land alongside the 9-ii dashboards). */}
        <Route
          path="admin/portal-accounts"
          element={
            <RequireAuth permission="Portal.ManageAccounts">
              <PortalAccountsPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/portal-accounts/send-signup-link"
          element={
            <RequireAuth permission="Portal.ManageAccounts">
              <PortalSignupLinkPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/portal-accounts/:id"
          element={
            <RequireAuth permission="Portal.ManageAccounts">
              <PortalAccountDetailPage />
            </RequireAuth>
          }
        />
        {/* External Intake & Collection v1.0 PR 7 — Loan-Administrator
            staging review queue + approve-and-file. Gated by
            Collection.Staging.ReviewAndFile (seeded onto B1 + Admin). */}
        <Route
          path="collection/staging"
          element={
            <RequireAuth permission="Collection.Staging.ReviewAndFile">
              <CollectionStagingQueuePage />
            </RequireAuth>
          }
        />
        <Route
          path="collection/staging/:id"
          element={
            <RequireAuth permission="Collection.Staging.ReviewAndFile">
              <CollectionStagingReviewPage />
            </RequireAuth>
          }
        />
        {/* Party Surfaces (F7) — the global entity Review Queue: one row per
            portal account across the six party types, rolling up its
            collection-review workload. Same gate as the staging queue it
            aggregates. */}
        <Route
          path="collection/review-queue"
          element={
            <RequireAuth permission="Collection.Staging.ReviewAndFile">
              <GlobalReviewQueuePage />
            </RequireAuth>
          }
        />
        {/* External Intake & Collection v1.0 PR 8 (Series 1) — staff
            "create & send a package" surface. Account-First Phase 4
            removed the standalone /collection/packages index; the SPA
            redirects it to the consolidated "External Collection" hub.
            Per-id + /new routes stay live indefinitely so email reminders
            and bookmarks survive (spec §10 decision 5). */}
        <Route
          path="collection/packages"
          element={<Navigate to="/admin/portal-accounts" replace />}
        />
        <Route
          path="collection/packages/new"
          element={
            <RequireAuth permission="Collection.ManagePackages">
              <CollectionPackageNewPage />
            </RequireAuth>
          }
        />
        <Route
          path="collection/packages/:id"
          element={
            <RequireAuth permission="Collection.ReadPackages">
              <CollectionPackageDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="reports"
          element={
            <RequireAuth permission="Reports.Read">
              <ReportsPage />
            </RequireAuth>
          }
        />
        <Route
          path="escrow"
          element={
            <RequireAuth permission="Escrow.Read">
              <EscrowListPage />
            </RequireAuth>
          }
        />
        <Route
          path="escrow/:id"
          element={
            <RequireAuth permission="Escrow.Read">
              <EscrowDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="reports/generate"
          element={
            <RequireAuth permission="Reports.Generate">
              <ReportGeneratePage />
            </RequireAuth>
          }
        />
        <Route
          path="reports/:id"
          element={
            <RequireAuth permission="Reports.Read">
              {/* v3.2 §12.2 — ReportDetailRouter dispatches to the new
                  stage-aware viewer (ReportV32DetailPage) when the
                  report carries a GenerationStage, or falls through to
                  the legacy ReportViewerPage for pre-v3.2 rows. The
                  URL stays /reports/:id so bookmarks survive. */}
              <ReportDetailRouter />
            </RequireAuth>
          }
        />
        <Route
          path="reports/:id/legacy"
          element={
            <RequireAuth permission="Reports.Read">
              <ReportViewerPage />
            </RequireAuth>
          }
        />
        {/* Payment System v3.0 PR 5 — Payment Instruction Reports */}
        <Route
          path="pirs"
          element={
            <RequireAuth permission="PIR.Generate">
              <PirsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="pirs/new"
          element={
            <RequireAuth permission="PIR.Generate">
              <PirGeneratePage />
            </RequireAuth>
          }
        />
        <Route
          path="pirs/:id"
          element={
            <RequireAuth permission="Payments.Read">
              <PirDetailPage />
            </RequireAuth>
          }
        />
        {/* Payment System v3.0 (WS1) — Servicer Instruction Reports (inverse of PIR) */}
        <Route
          path="servicer-instructions"
          element={
            <RequireAuth permission="ServicerInstruction.Generate">
              <ServicerInstructionsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="servicer-instructions/new"
          element={
            <RequireAuth permission="ServicerInstruction.Generate">
              <ServicerInstructionGeneratePage />
            </RequireAuth>
          }
        />
        <Route
          path="servicer-instructions/:id"
          element={
            <RequireAuth permission="Payments.Read">
              <ServicerInstructionDetailPage />
            </RequireAuth>
          }
        />
        {/* Payment System v3.0 PR 11 — four ledger views */}
        <Route
          path="ledgers/loans/:loanId/activity"
          element={
            <RequireAuth permission="Loans.Read">
              <LoanActivityLedgerPage />
            </RequireAuth>
          }
        />
        <Route
          path="ledgers/pools/:id"
          element={
            <RequireAuth permission="SpvPool.Read">
              <PoolLedgerPage />
            </RequireAuth>
          }
        />
        <Route
          path="ledgers/pools/:id/tiers/:tier"
          element={
            <RequireAuth permission="SpvPool.Read">
              <TierLedgerPage />
            </RequireAuth>
          }
        />
        <Route
          path="ledgers/investors/:investorId"
          element={
            <RequireAuth permission="Investor.Read">
              <InvestorLedgerPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokers"
          element={
            <RequireAuth permission="Brokers.Read">
              <BrokersPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokers/applications"
          element={
            <RequireAuth permission="Broker.Applications.Approve">
              <BrokerApplicationsPage />
            </RequireAuth>
          }
        />
        {/* Broker Channel Batch (WS6) — team registry + dashboard. Declared
            before brokers/:id (the static "teams" segment outranks :id in
            v6 route ranking regardless, but keep the reading order honest). */}
        <Route
          path="brokers/teams"
          element={
            <RequireAuth permission="Brokers.Read">
              <BrokerTeamsPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokers/teams/:id"
          element={
            <RequireAuth permission="Brokers.Read">
              <BrokerTeamDashboardPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokers/new"
          element={
            <RequireAuth permission="Brokers.Create">
              <BrokerEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokers/:id"
          element={
            <RequireAuth permission="Brokers.Read">
              <BrokerDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokers/:id/edit"
          element={
            <RequireAuth permission="Brokers.Update">
              <BrokerEditPage />
            </RequireAuth>
          }
        />

        {/* Deal Pipeline spec §5.6 — counterparty master records (standalone). */}
        {/* Deal Pipeline spec §5.6 — Borrowers / Sellers party surfaces. The
            legacy counterparty routes below stay registered after the sunset:
            Businesses is a sidebar entry and other pages link to persons and
            entities. */}
        <Route
          path="borrowers"
          element={
            <RequireAuth permission="Borrowers.Read">
              <BorrowersPage />
            </RequireAuth>
          }
        />
        <Route
          path="borrowers/new"
          element={
            <RequireAuth permission="Borrowers.Create">
              <BorrowerEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="borrowers/:id"
          element={
            <RequireAuth permission="Borrowers.Read">
              <BorrowerDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="borrowers/:id/edit"
          element={
            <RequireAuth permission="Borrowers.Update">
              <BorrowerEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="sellers"
          element={
            <RequireAuth permission="Sellers.Read">
              <SellersPage />
            </RequireAuth>
          }
        />
        <Route
          path="sellers/new"
          element={
            <RequireAuth permission="Sellers.Create">
              <SellerEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="sellers/:id"
          element={
            <RequireAuth permission="Sellers.Read">
              <SellerDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="sellers/:id/edit"
          element={
            <RequireAuth permission="Sellers.Update">
              <SellerEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="counterparties/persons"
          element={<RequireAuth permission="Persons.Read"><PersonListPage /></RequireAuth>}
        />
        <Route
          path="counterparties/persons/new"
          element={<RequireAuth permission="Persons.Create"><PersonEditPage /></RequireAuth>}
        />
        <Route
          path="counterparties/persons/:id"
          element={<RequireAuth permission="Persons.Read"><PersonDetailPage /></RequireAuth>}
        />
        <Route
          path="counterparties/persons/:id/edit"
          element={<RequireAuth permission="Persons.Update"><PersonEditPage /></RequireAuth>}
        />
        <Route
          path="counterparties/entities"
          element={<RequireAuth permission="Entities.Read"><EntityListPage /></RequireAuth>}
        />
        <Route
          path="counterparties/entities/new"
          element={<RequireAuth permission="Entities.Create"><EntityEditPage /></RequireAuth>}
        />
        <Route
          path="counterparties/entities/:id"
          element={<RequireAuth permission="Entities.Read"><EntityDetailPage /></RequireAuth>}
        />
        <Route
          path="counterparties/entities/:id/edit"
          element={<RequireAuth permission="Entities.Update"><EntityEditPage /></RequireAuth>}
        />
        <Route
          path="counterparties/businesses"
          element={<RequireAuth permission="Businesses.Read"><BusinessListPage /></RequireAuth>}
        />
        <Route
          path="counterparties/businesses/new"
          element={<RequireAuth permission="Businesses.Create"><BusinessEditPage /></RequireAuth>}
        />
        <Route
          path="counterparties/businesses/:id"
          element={<RequireAuth permission="Businesses.Read"><BusinessDetailPage /></RequireAuth>}
        />
        <Route
          path="counterparties/businesses/:id/edit"
          element={<RequireAuth permission="Businesses.Update"><BusinessEditPage /></RequireAuth>}
        />

        {/* Broker CRM v3.0 — Leads, Territories, Import */}
        <Route
          path="leads"
          element={
            <RequireAuth permission="Leads.Read">
              <LeadsPage />
            </RequireAuth>
          }
        />
        <Route
          path="leads/import"
          element={
            <RequireAuth permission="Leads.Import">
              <LeadImportPage />
            </RequireAuth>
          }
        />
        <Route
          path="leads/new"
          element={
            <RequireAuth permission="Leads.Create">
              <LeadEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="leads/:id"
          element={
            <RequireAuth permission="Leads.Read">
              <LeadDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="leads/:id/edit"
          element={
            <RequireAuth permission="Leads.Update">
              <LeadEditPage />
            </RequireAuth>
          }
        />
        {/* Lead Generation System — internal management section. Earnings is
            route-gated View; its review/lock actions self-gate on
            LeadGen.ReviewEarnings. Settings is route-gated ManagePlan. */}
        <Route
          path="lead-generation/preleads"
          element={
            <RequireAuth permission="LeadGen.View">
              <PreleadsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="lead-generation/generators"
          element={
            <RequireAuth permission="LeadGen.View">
              <GeneratorsRosterPage />
            </RequireAuth>
          }
        />
        <Route
          path="lead-generation/generators/:id"
          element={
            <RequireAuth permission="LeadGen.View">
              <GeneratorDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="lead-generation/earnings"
          element={
            <RequireAuth permission="LeadGen.View">
              <EarningsReviewPage />
            </RequireAuth>
          }
        />
        <Route
          path="lead-generation/ledger"
          element={
            <RequireAuth permission="LeadGen.View">
              <PayPeriodLedgerPage />
            </RequireAuth>
          }
        />
        <Route
          path="lead-generation/settings"
          element={
            <RequireAuth permission="LeadGen.ManagePlan">
              <CompensationPlanSettingsPage />
            </RequireAuth>
          }
        />
        {/* Brokerage Module v1.0 — covering brokerage firms. */}
        <Route
          path="brokerages"
          element={
            <RequireAuth permission="Brokerages.Read">
              <BrokeragesPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokerages/new"
          element={
            <RequireAuth permission="Brokerages.Create">
              <BrokerageEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokerages/:id"
          element={
            <RequireAuth permission="Brokerages.Read">
              <BrokerageDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="brokerages/:id/edit"
          element={
            <RequireAuth permission="Brokerages.Update">
              <BrokerageEditPage />
            </RequireAuth>
          }
        />
        {/* Buyer CRM (PR 2a). Each route gates on the permission ITS OWN
            controller checks — Buyers.Read, Listings.Read, Submissions.Read —
            all of which the universal augment grants to every internal role
            (L37), so these admit all staff and deny portal principals, which
            carry no phx:perm claims at all. Naming a module-wide permission
            instead would behave identically today and become a page that opens
            and then 403s the moment one of them is narrowed. The assignment
            queue is the MANAGER's surface (L35) and gates on ManageAll; the
            per-row write boundary is enforced server-side regardless of what
            any of these routes allow. */}
        <Route
          path="buyers"
          element={
            <RequireAuth permission="Buyers.Read">
              <BuyersListPage />
            </RequireAuth>
          }
        />
        {/* The create/edit/import surfaces gate on the WRITE permissions, not on
            Buyers.Read: a reader who can open the list must not be handed a form
            whose save is guaranteed to 403. The per-row ownership rule on an
            edit is separate and stays server-side (BuyerLeadDetailDto.canEdit).
            React Router ranks by specificity, so the static `buyers/new` and
            `buyers/import` beat `buyers/:id` regardless of the order here. */}
        <Route
          path="buyers/new"
          element={
            <RequireAuth permission="Buyers.Create">
              <BuyerEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyers/import"
          element={
            <RequireAuth permission="Buyers.Import">
              <BuyerImportPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyers/:id"
          element={
            <RequireAuth permission="Buyers.Read">
              <BuyerDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyers/:id/edit"
          element={
            <RequireAuth permission="Buyers.Update">
              <BuyerEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="listings"
          element={
            <RequireAuth permission="Listings.Read">
              <ListingsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="listings/:id"
          element={
            <RequireAuth permission="Listings.Read">
              <ListingDetailPage />
            </RequireAuth>
          }
        />
        {/* R6 — listing agent research has its own page, not a drawer. */}
        <Route
          path="listings/:id/agent-research"
          element={
            <RequireAuth permission="Listings.Read">
              <ListingAgentResearchPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyer-submissions"
          element={
            <RequireAuth permission="Submissions.Read">
              <BuyerSubmissionsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyer-submissions/:id"
          element={
            <RequireAuth permission="Submissions.Read">
              <BuyerSubmissionDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyer-assignments"
          element={
            <RequireAuth permission="Buyers.ManageAll">
              <BuyerAssignmentQueuePage />
            </RequireAuth>
          }
        />
        {/* PR 2b — the allocation POLICY (how many buyers a specialist earns) is
            a separate authority from ManageAll's dispatching of one buyer, so it
            gates on its own permission: F1 and ADMIN, never F2. A specialist who
            could set their own ratio is the whole thing the ratio prevents. */}
        <Route
          path="buyers/allocation"
          element={
            <RequireAuth permission="Buyers.ManageAllocation">
              <BuyerAllocationSettingsPage />
            </RequireAuth>
          }
        />
        {/* Multi-manager teams (WS4). The static "teams" and "advertising"
            segments are declared BEFORE any buyers/:id route for the reason the
            broker teams routes give: v6 ranks a static segment above a param
            regardless, but the reading order should say so too.

            Read-gated, not manage-gated: a specialist opens their own team to
            see who is on it. Every write inside is separately gated. */}
        <Route
          path="buyers/teams"
          element={
            <RequireAuth permission="Buyers.Read">
              <BuyerTeamsPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyers/teams/:id"
          element={
            <RequireAuth permission="Buyers.Read">
              <BuyerTeamDetailPage />
            </RequireAuth>
          }
        />
        {/* WS-B4 — reports. A static leaf beside `teams`, declared before
            buyers/:id for the same reading-order reason. */}
        <Route
          path="buyers/reports"
          element={
            <RequireAuth permission="Buyers.Read">
              <BuyerReportsPage />
            </RequireAuth>
          }
        />
        <Route
          path="buyers/advertising"
          element={
            <RequireAuth permission="BuyerAdvertising.Read">
              <BuyerAdvertisingPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/territories"
          element={
            <RequireAuth permission="Territories.Manage">
              <TerritoriesPage />
            </RequireAuth>
          }
        />
        {/* The Pipeline UI mounts under
            /deal-flow/* (its canonical home). Legacy
            /pipeline/* URLs redirect to keep deep bookmarks alive. */}
        <Route
          path="deal-flow/pipeline"
          element={
            <RequireAuth permission="Deals.Read">
              <PipelinePage />
            </RequireAuth>
          }
        />
        <Route
          path="deal-flow/pipeline/archive"
          element={
            <RequireAuth permission="Deals.Read">
              <PipelineArchivePage />
            </RequireAuth>
          }
        />
        <Route
          path="deal-flow/deals/:dealId"
          element={
            <RequireAuth permission="Deals.Read">
              <DealDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="deal-flow/deals/:dealId/edit"
          element={
            <RequireAuth permission="Deals.Update">
              <DealEditPage />
            </RequireAuth>
          }
        />
        {/* Deal Submission spec §7 — staff Deal Staging
            review queue + per-submission editor. Gated by
            DealSubmission.Review (every staff role holds it). */}
        <Route
          path="deal-flow/deal-staging"
          element={
            <RequireAuth permission="DealSubmission.Review">
              <DealStagingQueuePage />
            </RequireAuth>
          }
        />
        <Route
          path="deal-flow/deal-staging/:id"
          element={
            <RequireAuth permission="DealSubmission.Review">
              <DealStagingReviewPage />
            </RequireAuth>
          }
        />
        {/* Deal-flow Metrics dashboard. */}
        <Route
          path="deal-flow/metrics"
          element={
            <RequireAuth permission="DealFlow.ViewMetrics">
              <MetricsDashboard />
            </RequireAuth>
          }
        />
        {/* Deal-flow Failure Tracking executive surface. */}
        <Route
          path="deal-flow/failure-tracking"
          element={
            <RequireAuth permission="DealFlow.ViewFailures">
              <FailureTrackingPage />
            </RequireAuth>
          }
        />
        {/* Deal-flow Escalation Management surface. */}
        <Route
          path="deal-flow/escalations"
          element={
            <RequireAuth permission="DealFlow.ViewEscalations">
              <EscalationsPage />
            </RequireAuth>
          }
        />
        {/* Closing-gate Bypass admin console (ADMIN-only). */}
        <Route
          path="deal-flow/admin-bypass"
          element={
            <RequireAuth permission="DealFlow.BypassClosingGate">
              <AdminBypassConsolePage />
            </RequireAuth>
          }
        />
        {/* Prequalification System v1 — admin surface over public-funnel
            submissions (leads-template clone). */}
        <Route
          path="deal-flow/prequalification"
          element={
            <RequireAuth permission="Prequalification.Read">
              <PrequalificationListPage />
            </RequireAuth>
          }
        />
        <Route
          path="deal-flow/prequalification/documents"
          element={
            <RequireAuth permission="Prequalification.ManageDocuments">
              <PrequalDocumentEditorPage />
            </RequireAuth>
          }
        />
        {/* The uploaded per-role program PDF. Same permission as the document
            language editor beside it — both are customer-facing prequalification
            collateral. Registered BEFORE "/:id", like "documents" above and
            "partners/brands/new" below, so it never binds id="brochure". */}
        <Route
          path="deal-flow/prequalification/brochure"
          element={
            <RequireAuth permission="Prequalification.ManageDocuments">
              <ProgramBrochurePage />
            </RequireAuth>
          }
        />
        <Route
          path="deal-flow/prequalification/:id"
          element={
            <RequireAuth permission="Prequalification.Read">
              <PrequalificationDetailPage />
            </RequireAuth>
          }
        />
        {/* White-Label / Partner-Branded Prequalification — staff "Partner
            Brands" admin (list / create / edit / toggle). The "/new" static
            route is registered before "/:id" so it never binds id="new". */}
        <Route
          path="partners/brands"
          element={
            <RequireAuth permission="Partners.ManageBrands">
              <PartnerBrandsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="partners/brands/new"
          element={
            <RequireAuth permission="Partners.ManageBrands">
              <PartnerBrandCreateWizard />
            </RequireAuth>
          }
        />
        <Route
          path="partners/brands/:id"
          element={
            <RequireAuth permission="Partners.ManageBrands">
              <PartnerBrandEditPage />
            </RequireAuth>
          }
        />
        {/* Reunderwriting Module (Tier 3) PR 3 — pipeline + case detail.
            Gated server-side by [FeatureFlag("reunderwriting-v1")]; the
            client also checks VITE_FEATURE_REUNDERWRITING_V1 inside each
            page so the route renders an explicit "disabled" notice when
            the flag is off rather than an empty screen. */}
        <Route
          path="reunderwriting/pipeline"
          element={
            <RequireAuth permission="Reunderwriting.ViewCase">
              <ReunderwritingPipelinePage />
            </RequireAuth>
          }
        />
        <Route
          path="reunderwriting/cases/:caseId"
          element={
            <RequireAuth permission="Reunderwriting.ViewCase">
              <ReunderwritingCaseDetailPage />
            </RequireAuth>
          }
        />
        {/* Reunderwriting Module (Tier 3) PR 4 — Metrics + Failure Tracking
            + Escalations executive surfaces. Same feature-flag gate as
            PR 3 pages (each renders a "disabled" notice when the v1 flag
            is off). */}
        <Route
          path="reunderwriting/metrics"
          element={
            <RequireAuth permission="Reunderwriting.ViewMetrics">
              <ReunderwritingMetricsDashboard />
            </RequireAuth>
          }
        />
        <Route
          path="reunderwriting/failure-tracking"
          element={
            <RequireAuth permission="Reunderwriting.ViewFailures">
              <ReunderwritingFailureTrackingPage />
            </RequireAuth>
          }
        />
        <Route
          path="reunderwriting/escalations"
          element={
            <RequireAuth permission="Reunderwriting.ViewEscalations">
              <ReunderwritingEscalationsPage />
            </RequireAuth>
          }
        />
        {/* 301-style redirects for legacy /pipeline
            URLs. React Router's <Navigate replace> emits a client-side
            redirect, which is the SPA equivalent of a 301 for these
            paths. */}
        <Route path="pipeline" element={<Navigate to="/deal-flow/pipeline" replace />} />
        <Route path="pipeline/archive" element={<Navigate to="/deal-flow/pipeline/archive" replace />} />
        <Route path="pipeline/:dealId" element={<RedirectPipelineDeal />} />
        <Route path="pipeline/:dealId/edit" element={<RedirectPipelineDealEdit />} />
        {/* Adaptive role dashboard — the three typed-URL role dashboards are
            absorbed into the "/" widget catalog (their queues render as
            recipe widgets). Redirects keep old bookmarks working. */}
        <Route path="dashboard/liaison" element={<Navigate to="/" replace />} />
        <Route path="dashboard/loan-admin" element={<Navigate to="/" replace />} />
        <Route path="dashboard/manager" element={<Navigate to="/" replace />} />
        {/* The retired Underwriting workspace, Credit Committee,
            and Closing orchestration routes are gone. Catch-all entries
            below render a 410-style "this page has moved" component so
            deep links land somewhere useful. */}
        <Route path="underwriting/*" element={<GonePage />} />
        <Route path="credit-committee/*" element={<GonePage />} />
        <Route path="closing/*" element={<GonePage />} />
        {/* Portfolio Administration v1.0 PR 0 — the new /portfolio-admin/*
            URL space. The Loans / Vendors entries re-mount the existing
            PlaceholderPage stubs (real implementations land in PRs 3-5);
            the five new sub-pages render ComingSoonPage placeholders that
            name the PR each one is scheduled for. Old /loans, /vendors,
            /defaults, /portfolios, /vfi-dashboard, /compliance-calendar
            URLs 301-redirect to the appropriate new path below. */}
        <Route
          path="portfolio-admin/loans"
          element={
            <RequireAuth permission="Loans.Read">
              <LoansListPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/loans/:loanId"
          element={
            <RequireAuth permission="Loans.Read">
              <LoanDetailPage />
            </RequireAuth>
          }
        />
        {/* Portfolios — named loan groupings: registry + per-portfolio
            dashboard (group headers and portfolio names link here). */}
        <Route
          path="portfolio-admin/portfolios"
          element={
            <RequireAuth permission="Loans.Read">
              <PortfoliosListPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/portfolios/:portfolioId"
          element={
            <RequireAuth permission="Loans.Read">
              <PortfolioDashboardPage />
            </RequireAuth>
          }
        />
        {/* Finance build — cross-loan money ledgers (Finance nav group). The
            per-loan views live on the loan Financials tab; these are the
            book-wide rollups. All gated Loans.Read. */}
        <Route
          path="portfolio-admin/income-overview"
          element={
            <RequireAuth permission="Loans.Read">
              <IncomeOverviewPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/income-overview/loans/:loanId"
          element={
            <RequireAuth permission="Loans.Read">
              <IncomeOverviewLoanPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/loan-payments"
          element={
            <RequireAuth permission="Loans.Read">
              <LoanPaymentsPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/fees"
          element={
            <RequireAuth permission="Loans.Read">
              <FeesLedgerPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/cost-recovery"
          element={
            <RequireAuth permission="Loans.Read">
              <CostRecoveryPage />
            </RequireAuth>
          }
        />
        {/* Pre-pool waterfall alignment — B3 approve/waive queue for
            system-assessed fees (late fee / NSF / default interest). */}
        <Route
          path="portfolio-admin/fee-review"
          element={
            <RequireAuth permission="Fees.Review">
              <FeeReviewPage />
            </RequireAuth>
          }
        />
        {/* SP-2 — B3 Monthly Statements queues (review generated bills, send
            to the servicer, regenerate returned ones). The page gates on
            Statements.Generate OR the ADMIN role in-page. */}
        <Route
          path="portfolio-admin/statements"
          element={
            <RequireAuth>
              <StatementQueuePage />
            </RequireAuth>
          }
        />
        {/* Distribution Gate (B3 payout gate) — the B3 servicing-run review
            queue: approve a recorded run (release payout) or reject it (unwind).
            Gates on Payments.Review OR the ADMIN role in-page. */}
        <Route
          path="portfolio-admin/payment-reviews"
          element={
            <RequireAuth>
              <ServicingReviewQueuePage />
            </RequireAuth>
          }
        />
        {/* Distribution Gate PR-2 — the per-line B3 review screen for one held
            run: rule checks, recipient corrections (D-13), recalculate. */}
        <Route
          path="portfolio-admin/payment-reviews/:paymentId"
          element={
            <RequireAuth>
              <ServicingReviewDetailPage />
            </RequireAuth>
          }
        />
        {/* PR-F2 — per-state card-surcharge config for buyer statement payments. */}
        <Route
          path="portfolio-admin/card-surcharge"
          element={
            <RequireAuth permission="Portfolio.ManageTpsStripe">
              <CardSurchargeConfigPage />
            </RequireAuth>
          }
        />
        {/* Broker Commission Modeler — the four Phoenix-set program numbers every
            modeled figure is computed against, admin-editable without a deploy.
            Partners.ManageBrands is REUSED deliberately (it already carries the
            broker-tooling audience C0/C1/C5 + ADMIN); no new permission was minted. */}
        <Route
          path="portfolio-admin/commission-modeler-terms"
          element={
            <RequireAuth permission="Partners.ManageBrands">
              <CommissionModelerTermsPage />
            </RequireAuth>
          }
        />
        {/* PR-J — TPS Oversight staff console. */}
        <Route
          path="portfolio-admin/tps-oversight"
          element={
            <RequireAuth permission="Portfolio.OversightView">
              <TpsOversightPage />
            </RequireAuth>
          }
        />
        {/* Transitions PR-1 — cross-loan Transitions console (reads ride
            Loans.Read; writes happen on the loan's Transitions tab). */}
        <Route
          path="portfolio-admin/transitions"
          element={
            <RequireAuth permission="Loans.Read">
              <TransitionsConsolePage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/loans/:loanId/right-size"
          element={
            <RequireAuth permission="RightSize.Initiate">
              <RightSizeWizard />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/loans/:loanId/resale"
          element={
            <RequireAuth permission="Resale.Initiate">
              <ResaleWizard />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/loans/:loanId/financial-closing"
          element={
            <RequireAuth permission="Resale.FinancialClosing">
              <FinancialClosingWizard />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/loans/:loanId/*"
          element={
            <RequireAuth permission="Loans.Read">
              <LoanDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/vendors"
          element={
            <RequireAuth permission="Vendors.Read">
              <VendorsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/vendors/:vendorId"
          element={
            <RequireAuth permission="Vendors.Read">
              <VendorDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/vendors/:vendorId/*"
          element={
            <RequireAuth permission="Vendors.Read">
              <VendorDetailPage />
            </RequireAuth>
          }
        />
        {/* Vendor Program v2 PR 2 — borrower-complaint triage queue. */}
        <Route
          path="portfolio-admin/complaints"
          element={
            <RequireAuth permission="Vendors.Read">
              <VendorComplaintsPage />
            </RequireAuth>
          }
        />
        {/* Annual Vendor Audit — the yearly market-check registry. Audit
            detail is a DRAWER (?audit=<id>), deliberately not a :id route:
            the completeness headline and the excluded group are the point of
            the surface, and they belong beside the row being read. */}
        <Route
          path="portfolio-admin/vendor-audits"
          element={
            <RequireAuth permission="Vendors.Read">
              <VendorAuditsPage />
            </RequireAuth>
          }
        />
        {/* Vendor Program v2 PR 3 — VFI Accounting workspace (review
            queue + draft invoice pool + formal accounting reports). */}
        <Route
          path="portfolio-admin/vfi-accounting"
          element={
            <RequireAuth permission="VendorBilling.Read">
              <VfiAccountingPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/local-enforcers"
          element={
            <RequireAuth permission="Enforcer.Read">
              <LocalEnforcersListPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/local-enforcers/:enforcerId"
          element={
            <RequireAuth permission="Enforcer.Read">
              <LocalEnforcerDetailPage />
            </RequireAuth>
          }
        />
        {/* Portfolio Administration v1.0 PR 6 — waterfalls editor + loan tape. */}
        <Route
          path="portfolio-admin/waterfalls"
          element={
            <RequireAuth anyPermission={["Waterfall.ConfigEdit", "Waterfall.ConfigApprove"]}>
              <WaterfallsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/waterfalls/:code"
          element={
            <RequireAuth anyPermission={["Waterfall.ConfigEdit", "Waterfall.ConfigApprove"]}>
              <WaterfallDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/loan-tape"
          element={
            <RequireAuth permission="LoanTape.Read">
              <LoanTapePage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/reporting"
          element={
            <RequireAuth permission="Loans.Read">
              <ReportingPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/metrics"
          element={
            <RequireAuth permission="Metrics.Read">
              <MetricsPage />
            </RequireAuth>
          }
        />
        {/* The Failure Tracking page retired — its default-case role moved
            to the Defaults & Workout cockpit (Governance), LoanFailure rows
            auto-resolve when their source condition clears, and the
            surviving condition surfaces live on the Compliance cockpit +
            the owning loan tabs. NOTE the cockpit is gated Defaults.Read
            (B4/E1/ADMIN) — narrower than the old page's Loans.Read; a
            non-holder following an old link gets the standard no-access
            handling. (The Deal Flow /deal-flow/failure-tracking surface is
            a different subsystem and stays.) */}
        <Route
          path="portfolio-admin/failure-tracking"
          element={<Navigate to="/defaults-workout" replace />}
        />
        {/* Baselayer Background Checks — staff module. The UCC-filing detail
            route is registered before the check detail route so its literal
            path segment isn't swallowed by the :id param. */}
        <Route
          path="background-checks"
          element={
            <RequireAuth permission="BackgroundCheck.Read">
              <BackgroundChecksPage />
            </RequireAuth>
          }
        />
        <Route
          path="background-checks/ucc-filings/:id"
          element={
            <RequireAuth permission="BackgroundCheck.Read">
              <BgcUccFilingDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="background-checks/:id/liens/:lienId"
          element={
            <RequireAuth permission="BackgroundCheck.Read">
              <LienDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="background-checks/:id/litigations/:caseId"
          element={
            <RequireAuth permission="BackgroundCheck.Read">
              <LitigationDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="background-checks/:id"
          element={
            <RequireAuth permission="BackgroundCheck.Read">
              <BackgroundCheckDetailPage />
            </RequireAuth>
          }
        />
        {/* WS8 WS-5 — TPS (Third-Party Servicer) registry. */}
        <Route
          path="portfolio-admin/tps"
          element={
            <RequireAuth permission="Tps.Read">
              <TpsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="portfolio-admin/tps/:id"
          element={
            <RequireAuth permission="Tps.Read">
              <TpsDetailPage />
            </RequireAuth>
          }
        />
        {/* Portfolio Administration v1.0 PR 0 — 301-style redirects from
            the legacy /loans, /vendors, /defaults, /portfolios,
            /vfi-dashboard, and /compliance-calendar URLs into the new
            /portfolio-admin/* space. <Navigate replace> is the SPA
            equivalent of a 301; bookmarks and deep links keep working
            indefinitely (no time-limited removal per spec §17.2). */}
        <Route path="loans" element={<Navigate to="/portfolio-admin/loans" replace />} />
        <Route path="loans/:loanId" element={<RedirectLoan />} />
        <Route path="loans/:loanId/*" element={<RedirectLoanSubpath />} />
        <Route
          path="portfolios"
          element={<Navigate to="/portfolio-admin/loans?group=portfolio" replace />}
        />
        <Route path="portfolios/:portfolioId" element={<RedirectPortfolio />} />
        <Route path="vendors" element={<Navigate to="/portfolio-admin/vendors" replace />} />
        <Route path="vendors/:vendorId" element={<RedirectVendor />} />
        <Route path="vendors/:vendorId/*" element={<RedirectVendorSubpath />} />
        {/* Vendor Program v2 PR 3 — the VFI Dashboard view consolidated
            into the VFI Accounting page. */}
        <Route
          path="vfi-dashboard"
          element={<Navigate to="/portfolio-admin/vfi-accounting" replace />}
        />
        <Route path="defaults" element={<Navigate to="/portfolio-admin/loans" replace />} />
        <Route path="defaults/:caseId" element={<RedirectDefaultCase />} />
        {/* The unified Due Dates surface retired with the loan-detail tab
            (per-tab strips + the Overview needs-attention feed replaced
            it); the loans list is the closest cross-loan home. */}
        <Route
          path="compliance-calendar"
          element={<Navigate to="/portfolio-admin/loans" replace />}
        />
        {/* SPV Pool v1.0 PR 9 — the /capital-markets cross-pool dashboard. */}
        <Route
          path="capital-markets"
          element={
            <RequireAuth permission="SpvPool.Read">
              <CapitalMarketsDashboard />
            </RequireAuth>
          }
        />
        {/* SPV Pool v1.0 PR 4 — Capital Markets pool + trust workspace.
            Replaces the legacy /spv placeholder route. */}
        <Route
          path="capital-markets/pools"
          element={
            <RequireAuth permission="SpvPool.Read">
              <PoolListPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/pools/new"
          element={
            <RequireAuth permission="SpvPool.Build">
              <PoolFormPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/pools/:id"
          element={
            <RequireAuth permission="SpvPool.Read">
              <PoolDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/pools/:id/edit"
          element={
            <RequireAuth permission="SpvPool.Build">
              <PoolFormPage />
            </RequireAuth>
          }
        />
        {/* Payment System v3.0 PR 7 — multi-investor closing wizard
            and VFI inflow wizard. Both are route-driven pages (not
            modals) so the operator can deep-link mid-flow if needed. */}
        <Route
          path="capital-markets/pools/:id/closings/new"
          element={
            <RequireAuth permission="SpvPool.Build">
              <InvestorClosingWizard />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/pools/:id/vfi/new"
          element={
            <RequireAuth permission="SpvPool.Build">
              <VfiInflowWizard />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/trusts"
          element={
            <RequireAuth permission="Spv.Read">
              <TrustListPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/trusts/new"
          element={
            <RequireAuth permission="Spv.Manage">
              <TrustFormPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/trusts/:id"
          element={
            <RequireAuth permission="Spv.Read">
              <TrustDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/trusts/:id/edit"
          element={
            <RequireAuth permission="Spv.Manage">
              <TrustFormPage />
            </RequireAuth>
          }
        />
        {/* SPV Pool v1.0 PR 5 — Investor workspace. */}
        <Route
          path="capital-markets/investors"
          element={
            <RequireAuth permission="Investor.Read">
              <InvestorListPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/investors/:id"
          element={
            <RequireAuth permission="Investor.Read">
              <InvestorDetailPage />
            </RequireAuth>
          }
        />
        {/* SPV Pool v1.0 PR 5 — Service-provider workspace. The landing page
            carries four internal tabs; each tab's list GET is permission-
            gated server-side, so the route itself only requires auth. */}
        <Route
          path="capital-markets/service-providers"
          element={
            <RequireAuth>
              <ServiceProvidersLandingPage />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/indenture-trustees/:id"
          element={
            <RequireAuth permission="IndentureTrustee.Read">
              <ServiceProviderDetailPage
                config={PROVIDER_CONFIGS.IndentureTrustee}
              />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/trust-companies/:id"
          element={
            <RequireAuth permission="TrustCompany.Read">
              <ServiceProviderDetailPage
                config={PROVIDER_CONFIGS.TrustCompany}
              />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/placement-agents/:id"
          element={
            <RequireAuth permission="PlacementAgent.Read">
              <ServiceProviderDetailPage
                config={PROVIDER_CONFIGS.PlacementAgent}
              />
            </RequireAuth>
          }
        />
        <Route
          path="capital-markets/backup-servicers/:id"
          element={
            <RequireAuth permission="BackupServicer.Read">
              <ServiceProviderDetailPage
                config={PROVIDER_CONFIGS.BackupServicer}
              />
            </RequireAuth>
          }
        />
        {/* Legacy /spv deep links redirect into the new pool workspace. */}
        <Route
          path="spv"
          element={<Navigate to="/capital-markets/pools" replace />}
        />
        <Route
          path="investors"
          element={
            <RequireAuth permission="Investors.Read">
              <PlaceholderPage phase="Phase 4" title="Investor Reporting" description="Monthly, quarterly, annual reports; K-1/1099; portal." />
            </RequireAuth>
          }
        />
        {/* Governance cockpits — Compliance is the B4 cross-portfolio work
            queue (the former Legal Review workspace queue lives inside it
            as the "Annual legal reviews (LLCR)" section); Quality
            Assurance is the B5 sibling. The old /compliance/legal-review
            list URL redirects into the cockpit section (handled inside
            LegalReviewWorkspacePage, params preserved); the per-engagement
            workbench detail route survives untouched. */}
        <Route
          path="compliance"
          element={
            <RequireAuth permission="Compliance.Read">
              <ComplianceCockpitPage />
            </RequireAuth>
          }
        />
        <Route
          path="quality-assurance"
          element={
            <RequireAuth permission="Compliance.QaReview">
              <QualityAssuranceCockpitPage />
            </RequireAuth>
          }
        />
        {/* Defaults & Workout — the third Governance cockpit: one row per
            open DefaultCase across all loans (B4/E1 via Defaults.Read). */}
        <Route
          path="defaults-workout"
          element={
            <RequireAuth permission="Defaults.Read">
              <DefaultsWorkoutCockpitPage />
            </RequireAuth>
          }
        />
        <Route
          path="compliance/legal-review"
          element={
            <RequireAuth permission="Compliance.ViewExceptions">
              <LegalReviewWorkspacePage />
            </RequireAuth>
          }
        />
        <Route
          path="compliance/legal-review/:reviewId"
          element={
            <RequireAuth permission="Compliance.ViewExceptions">
              <LegalReviewWorkspacePage />
            </RequireAuth>
          }
        />
        <Route
          path="commissions"
          element={
            <RequireAuth permission="Claims.Read">
              <CommissionsPage />
            </RequireAuth>
          }
        />
        <Route
          path="commissions/new"
          element={
            <RequireAuth permission="Commission.ManualCreate">
              <ClaimEntryPage />
            </RequireAuth>
          }
        />
        <Route
          path="commissions/:id"
          element={
            <RequireAuth permission="Claims.Read">
              <ClaimDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="commissions/:id/edit"
          element={
            // Two audiences, two permissions. Commission.ManualCreate is the
            // ADMIN manual-entry path (it also gates `commissions/new`);
            // Claims.Revise is the claimant's, and it is the ONLY way a
            // contested claim gets answered — the sanctioned responses are
            // Revise and Withdraw, and Withdraw forfeits the money. Gating this
            // route on ManualCreate alone (which the lockdown makes ADMIN-only)
            // left every claimant with forfeit as their only move.
            <RequireAuth anyPermission={["Commission.ManualCreate", "Claims.Revise"]}>
              <ClaimEntryPage />
            </RequireAuth>
          }
        />
        <Route
          path="commissions/bulk"
          element={
            <RequireAuth permission="Commission.ManualCreate">
              <BulkEntryPage />
            </RequireAuth>
          }
        />
        <Route
          path="commissions/templates"
          element={
            <RequireAuth permission="Commission.ManualCreate">
              <TemplatesPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/commission-pools"
          element={
            <RequireAuth permission="Pools.Manage">
              <PoolAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/commission-periods"
          element={
            <RequireAuth permission="Commission.PeriodLock">
              <PeriodAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/commission-allocations"
          element={
            <RequireAuth permission="Commission.ManageAllocations">
              <AllocationAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/commission-rates"
          element={
            <RequireAuth permission="Commission.ManageRates">
              <CommissionRatesPage />
            </RequireAuth>
          }
        />
        {/* PR-6 — cross-claimant admin browse views. */}
        <Route
          path="admin/commissions/all"
          element={
            <RequireAuth permission="Claims.ReadAll">
              <AdminAllClaimsPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/commissions/payments"
          element={
            <RequireAuth permission="Payments.ReadAll">
              <AdminPaymentLedgerPage />
            </RequireAuth>
          }
        />

        {/* Internal Messaging v1.0 — every authenticated user can DM. */}
        <Route path="messages" element={<InboxPage />} />
        <Route path="messages/new" element={<ThreadPage />} />
        <Route path="messages/:id" element={<ThreadPage />} />

        {/* Tasks Module v1.0 — list view + detail page. List view is open
            to any authenticated user (visibility is filtered server-side).
            Tasks.Create is checked at the controls level inside the page. */}
        <Route path="tasks" element={<TasksListPage />} />
        <Route path="tasks/:id" element={<TaskDetailPage />} />

        {/* Calendar Appointments v1.0 — native calendar, a near-clone of the
            Tasks module. Open to any authenticated user (own-scope is
            enforced server-side); the manager "view another user's calendar"
            affordance is gated on Appointments.ViewAll inside the page. */}
        <Route path="calendar" element={<CalendarPage />} />

        {/* Communication Log v1.0 §9.1-§9.2 — central inbox + entry detail.
            Authenticated-only; per-action permissions (Communications.Log,
            Communications.ViewAll, Communications.Export) are checked
            inside the page. */}
        <Route path="communications" element={<CommunicationsInboxPage />} />
        <Route path="communications/:id" element={<CommunicationDetailPage />} />
        {/* Tasks v1.1 — admin tag management. */}
        <Route
          path="admin/tasks/tags"
          element={
            <RequireAuth permission="Tasks.ManageTags">
              <TagManagementPage />
            </RequireAuth>
          }
        />
        {/* Knowledge Base v1.0 PR 4 — Ask + Browse landing + admin surfaces.
            The page-level component additionally hides the Browse tab from
            users without BrowseLibrary so the gate is layered. */}
        <Route
          path="knowledge-base"
          element={
            <RequireAuth>
              <KnowledgeBasePage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/knowledge-base-documents"
          element={
            <RequireAuth permission="KnowledgeBase.ManageDocuments">
              <KnowledgeBaseDocumentsAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/knowledge-base-categories"
          element={
            <RequireAuth permission="KnowledgeBase.ManageDocuments">
              <KnowledgeBaseCategoriesAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/knowledge-base-tags"
          element={
            <RequireAuth permission="KnowledgeBase.ManageDocuments">
              <KnowledgeBaseTagsAdminPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/knowledge-base-access"
          element={
            <RequireAuth permission="KnowledgeBase.ManageDocuments">
              <KnowledgeBaseAccessMatrixPage />
            </RequireAuth>
          }
        />
        {/* Knowledge Base v1.0 PR 5 — read-only feedback review surface so
            admins can spot corpus gaps and tune the library. */}
        <Route
          path="admin/knowledge-base-queries"
          element={
            <RequireAuth permission="KnowledgeBase.ManageDocuments">
              <KnowledgeBaseQueriesAdminPage />
            </RequireAuth>
          }
        />
        {/* Knowledge Base AI-Assisted Uploader v1.0 PR 3 — read-only
            accuracy view over the AI Upload audit rows. */}
        <Route
          path="admin/knowledge-base-classification-accuracy"
          element={
            <RequireAuth permission="KnowledgeBase.ManageDocuments">
              <KnowledgeBaseClassificationAccuracyPage />
            </RequireAuth>
          }
        />
        <Route
          path="admin/portal-materials"
          element={
            <RequireAuth permission="PortalMaterials.Manage">
              <PortalMaterialsAdminPage />
            </RequireAuth>
          }
        />
        {/* Certifications Module v1.0 PR 2 — admin authoring UI for the
            cross-entity CertificationDefinition catalog. The route is
            permission-gated here; the feature flag is enforced server-
            side and the page renders a "feature not yet enabled" notice
            when the API 404s. */}
        <Route
          path="admin/certifications"
          element={
            <RequireAuth permission="CertificationDefinitions.Read">
              <CertificationsAdminPage />
            </RequireAuth>
          }
        />
        {/* Catch-all 404 — inside the shell so it keeps the app navigation. */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

function RedirectPipelineDealEdit() {
  const { dealId } = useParams<{ dealId: string }>();
  return <Navigate to={`/deal-flow/deals/${dealId}/edit`} replace />;
}

/**
 * Portfolio Administration v1.0 PR 0 — legacy URL redirects that preserve
 * route params and (via React Router's splat) any subpath the user
 * deep-linked. The redirects are indefinite (no time-limited removal per
 * spec §17.2 deferred question).
 */
function RedirectLoan() {
  const { loanId } = useParams<{ loanId: string }>();
  return <Navigate to={`/portfolio-admin/loans/${loanId}`} replace />;
}

function RedirectLoanSubpath() {
  const params = useParams();
  const loanId = params.loanId;
  const rest = params["*"] ?? "";
  return <Navigate to={`/portfolio-admin/loans/${loanId}${rest ? `/${rest}` : ""}`} replace />;
}

function RedirectPortfolio() {
  const { portfolioId } = useParams<{ portfolioId: string }>();
  // Portfolios now have a real dashboard — the old grouped-loans-list
  // approximation is retired as the redirect target.
  return <Navigate to={`/portfolio-admin/portfolios/${portfolioId}`} replace />;
}

function RedirectVendor() {
  const { vendorId } = useParams<{ vendorId: string }>();
  return <Navigate to={`/portfolio-admin/vendors/${vendorId}`} replace />;
}

function RedirectVendorSubpath() {
  const params = useParams();
  const vendorId = params.vendorId;
  const rest = params["*"] ?? "";
  return (
    <Navigate
      to={`/portfolio-admin/vendors/${vendorId}${rest ? `/${rest}` : ""}`}
      replace
    />
  );
}

function RedirectDefaultCase() {
  const { caseId } = useParams<{ caseId: string }>();
  return <Navigate to={`/portfolio-admin/loans?tab=defaults&case=${caseId}`} replace />;
}
